import svgPaths from '../imports/svg-mqj91w00zx';

interface PickupHeaderProps {
  onBack: () => void;
  unreadNotificationCount?: number;
  onNotificationClick?: () => void;
  cartItemCount?: number;
  onCartClick?: () => void;
}

export function PickupHeader({ onBack, unreadNotificationCount = 0, onNotificationClick, cartItemCount = 0, onCartClick }: PickupHeaderProps) {
  return (
    <div className="bg-primary relative size-full">
      <div className="flex flex-row items-center relative size-full">
        <div className="box-border content-stretch flex gap-[16px] items-center justify-between p-[20px] relative h-[50px] w-full">
          {/* Back Button */}
          <div className="h-[16.8px] relative shrink-0 w-[9.6px]">
            <button
              onClick={onBack}
              className="block size-full"
            >
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 12 21">
                <path d="M11.588 0.41098C11.4583 0.280705 11.3042 0.177346 11.1345 0.106823C10.9649 0.0363008 10.783 0 10.5993 0C10.4156 0 10.2337 0.0363008 10.0641 0.106823C9.89442 0.177346 9.74031 0.280705 9.61059 0.41098L0.326717 9.71087C0.223149 9.8144 0.140982 9.93738 0.0849197 10.0728C0.0288573 10.2082 0 10.3533 0 10.4999C0 10.6464 0.0288573 10.7916 0.0849197 10.9269C0.140982 11.0623 0.223149 11.1853 0.326717 11.2888L9.61059 20.5887C10.158 21.1371 11.0406 21.1371 11.588 20.5887C12.1354 20.0404 12.1354 19.1562 11.588 18.6079L3.49955 10.4943L11.5992 2.38063C12.1354 1.84345 12.1354 0.948157 11.588 0.41098Z" fill="white" />
              </svg>
            </button>
          </div>
          
          {/* Right side icons */}
          <div className="flex gap-[30px] items-center justify-end pr-[5px]">
            {/* Notification with counter */}
            <button 
              className="h-[23.088px] relative shrink-0 w-[20.8px] hover:bg-white/10 rounded-full transition-colors duration-200 flex items-center justify-center p-2"
              onClick={onNotificationClick}
            >
              <div className="absolute inset-[-2.78%_-3.09%]">
                <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 28 31">
                  <g>
                    <path d={svgPaths.p2d77c100} stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.60329" />
                    <path d={svgPaths.p2383a1c0} stroke="white" strokeMiterlimit="10" strokeWidth="1.60329" />
                  </g>
                </svg>
              </div>
              {unreadNotificationCount > 0 && (
                <div className="absolute bg-warning bottom-[51.49%] box-border content-stretch flex flex-col gap-[10px] items-center justify-center left-[46.15%] px-[2px] py-px right-0 rounded-[7px] top-0 min-w-[16px] h-[16px]">
                  <p className="font-['Noto_Sans:Medium',_sans-serif] font-medium leading-[normal] text-[12px] text-center text-nowrap text-white" style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}>
                    {unreadNotificationCount > 99 ? '99+' : unreadNotificationCount}
                  </p>
                </div>
              )}
            </button>

            {/* Cart with counter */}
            <button 
              className={`h-[23.1456px] relative shrink-0 w-[24.5272px] rounded-full transition-all duration-200 flex items-center justify-center p-2 ${
                cartItemCount === 0 
                  ? 'opacity-40 cursor-not-allowed' 
                  : 'hover:bg-white/10 cursor-pointer'
              }`}
              onClick={() => {
                if (cartItemCount > 0 && onCartClick) {
                  onCartClick();
                }
              }}
              disabled={cartItemCount === 0}
            >
              <div className="absolute bottom-0 left-[-2.63%] right-[-2.63%] top-[-2.79%]">
                <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 33 30">
                  <g>
                    <path d={svgPaths.p17059f00} stroke="white" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.61204" />
                    <path d={svgPaths.p11c36800} stroke="white" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.61204" />
                    <path d={svgPaths.p36edd280} fill="white" />
                    <path d={svgPaths.pdf3f780} fill="white" />
                  </g>
                </svg>
              </div>
              {cartItemCount > 0 && (
                <div className="absolute -right-2 -top-2 box-border inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-warning px-1">
                  <span className="font-['Noto_Sans:Medium',_sans-serif] font-medium leading-none text-[11px] text-center text-nowrap text-white" style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}>
                    {cartItemCount > 99 ? '99+' : cartItemCount}
                  </span>
                </div>
              )}
            </button>

            {/* Language Icon */}
            <button 
              className="relative shrink-0 size-[22.4px] hover:bg-white/10 rounded-full transition-colors duration-200 flex items-center justify-center"
              onClick={() => {
                // 설정 모달 열기 - 통화 및 언어 변경
                const event = new CustomEvent('openSettingsModal', {
                  detail: { type: 'currencyAndLanguage' }
                });
                window.dispatchEvent(event);
              }}
            >
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 28 28">
                <path d={svgPaths.p116ad280} fill="white" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
